
(function() {
  var GIFT_VARIANT_ID = 57196547834201;
  var MIN_SPEND_PENCE = 8000;
  var adding = false;

  function checkAndManageGift() {
    if (adding) return;
    adding = true;

    fetch("/cart.js").then(function(r) { return r.json(); }).then(function(cart) {
      var giftInCart = false;
      var giftKey = null;
      var giftQty = 0;
      var totalWithoutGift = 0;

      cart.items.forEach(function(item) {
        if (item.variant_id === GIFT_VARIANT_ID) {
          giftInCart = true;
          giftKey = item.key;
          giftQty = item.quantity;
        } else {
          totalWithoutGift += item.final_line_price;
        }
      });

      if (totalWithoutGift >= MIN_SPEND_PENCE && !giftInCart) {
        /* Add 1 gift */
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: [{ id: GIFT_VARIANT_ID, quantity: 1, properties: { "_free_gift": "true" } }] })
        }).then(function() {
          adding = false;
          if (window.location.pathname === "/cart") window.location.reload();
        }).catch(function() { adding = false; });
      } else if (totalWithoutGift < MIN_SPEND_PENCE && giftInCart && giftKey) {
        /* Remove gift - under threshold */
        fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: giftKey, quantity: 0 })
        }).then(function() {
          adding = false;
          if (window.location.pathname === "/cart") window.location.reload();
        }).catch(function() { adding = false; });
      } else if (giftInCart && giftQty > 1) {
        /* Cap at 1 - someone increased the quantity */
        fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: giftKey, quantity: 1 })
        }).then(function() {
          adding = false;
          if (window.location.pathname === "/cart") window.location.reload();
        }).catch(function() { adding = false; });
      } else {
        adding = false;
      }
    }).catch(function() { adding = false; });
  }

  var origFetch = window.fetch;
  window.fetch = function(url, opts) {
    var result = origFetch.apply(this, arguments);
    if (typeof url === "string" && (url.includes("/cart/add") || url.includes("/cart/change") || url.includes("/cart/update"))) {
      var bodyStr = (opts && opts.body && typeof opts.body === "string") ? opts.body : "";
      if (!bodyStr.includes("_free_gift") && !bodyStr.includes(String(GIFT_VARIANT_ID))) {
        result.then(function() { setTimeout(checkAndManageGift, 700); });
      }
    }
    return result;
  };

  setTimeout(checkAndManageGift, 500);

  document.addEventListener("submit", function(e) {
    if (e.target && e.target.action && e.target.action.includes("/cart")) {
      setTimeout(checkAndManageGift, 800);
    }
  }, true);

  document.addEventListener("click", function(e) {
    var el = e.target.closest ? e.target.closest("button, [data-quantity], .quantity-selector") : null;
    if (el) setTimeout(checkAndManageGift, 1000);
  }, true);

  /* Poll every 2 seconds on cart page to catch manual quantity changes */
  if (window.location.pathname === "/cart") {
    setInterval(checkAndManageGift, 2000);
  }

  /* Intercept checkout - force gift qty to 1 before proceeding */
  document.addEventListener("click", function(e) {
    var el = e.target.closest ? e.target.closest("a[href*='/checkout'], button[name='checkout'], input[name='checkout']") : null;
    if (!el) return;

    e.preventDefault();
    e.stopPropagation();

    fetch("/cart.js").then(function(r) { return r.json(); }).then(function(cart) {
      var needsFix = false;
      cart.items.forEach(function(item) {
        if (item.variant_id === GIFT_VARIANT_ID && item.quantity > 1) {
          needsFix = true;
        }
      });

      if (needsFix) {
        var giftItem = cart.items.find(function(item) { return item.variant_id === GIFT_VARIANT_ID; });
        fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: giftItem.key, quantity: 1 })
        }).then(function() {
          window.location.href = "/checkout";
        });
      } else {
        window.location.href = "/checkout";
      }
    }).catch(function() {
      window.location.href = "/checkout";
    });
  }, true);
})();
